namespace UUri {
  // Match all schemes including https://, mailto:, tel:
  export const hasScheme = (uri: string) => /^\w+:/.test(uri);

  export const hasOrigin = (uri: string, origin: string) =>
    uri === origin || uri.startsWith(`${origin}/`);
}

export default UUri;
